<sm-toolbar>
    <p-dropdown [styleClass]="'width400'" [options]="contents" [(ngModel)]="selectedContent" (ngModelChange)="updateFilter(true)"></p-dropdown>
    <span class="ml-5 mr-2">Dienstarten: </span>
    <p-multiSelect appendTo="body" selectionMode="multiple" [styleClass]="'width500'" [options]="jobDescriptions" [(ngModel)]="selectedJobDescriptions" (ngModelChange)="updateFilter(false)">
    </p-multiSelect>
</sm-toolbar>
<sm-table-on-push *ngIf="inited" [data]="table">
</sm-table-on-push>
